import axios from "../axios/vendors/auth.axios";
import i18n, { languages } from "../i18n/config";

const applyLanguageSettings = (lang: keyof typeof languages) => {
    document.body.dir = languages[lang].dir
    document.body.className = languages[lang].fontClass
    document.documentElement.lang = lang
    axios.defaults.headers.common['x-lang']=lang;
    
}
export const ChangeLanguage = async (lang: keyof typeof languages)=>{
    await i18n.changeLanguage(lang)
    applyLanguageSettings(lang)
    localStorage.setItem("preferred-language", lang)
};

export const initializeLanguage = () => {
    const savedLang = localStorage.getItem("preferred-language") as keyof typeof languages | null
    const currentLang = i18n.language as keyof typeof languages
    if(savedLang && savedLang != currentLang){
        i18n.changeLanguage(savedLang)
        applyLanguageSettings(savedLang)
    } else if (currentLang){
        applyLanguageSettings(currentLang)
    }
}